<form [formGroup]="filterOptionsForm">
    <div class="p-mt-3">

        <!--    Start : Filter Options Grid-->

        <div class="p-grid p-ai-center p-jc-between p-mx-0 p-mx-lg-2 p-mx-xl-0">

            <div class="p-col-12 p-lg-6 p-xl-3">
            <span class="p-input-icon-right p-float-label width-100">
                        <input (change)="searchByIdentifier($event)" formControlName="filterByIdentifier" type="text"
                               class="width-100" pInputText/>
                        <label>Search</label>
						<i class="pi pi-search"></i>
					</span>
            </div>

            <div class="p-col-12 p-lg-6 p-xl-4">
                <div class="p-grid p-ai-center p-jc-end">
                    <div class="p-col-6 p-sm-5">
                        <p-calendar (onSelect)="resetSearchBar()" [readonlyInput]="true" [monthNavigator]="true"
                                    [yearNavigator]="true" yearRange="2000:2030" dateFormat="dd-mm-yy"
                                    showButtonBar="true" styleClass="width-100" [showIcon]="true"
                                    formControlName="fromDate"
                                    placeholder="From Date"></p-calendar>
                    </div>
                    <div class="p-col-6 p-sm-5">
                        <p-calendar (onSelect)="resetSearchBar()" [readonlyInput]="true" [monthNavigator]="true"
                                    [yearNavigator]="true" yearRange="2000:2030" dateFormat="dd-mm-yy"
                                    showButtonBar="true" styleClass="width-100" [showIcon]="true"
                                    formControlName="toDate"
                                    placeholder="To Date"></p-calendar>
                    </div>
                    <div class="p-col-12 p-sm-2 p-text-right">
                        <button class="p-button-secondary p-px-4" type="button" (click)="applyFilterOptions()" pButton
                                pRipple label="Apply"></button>
                    </div>
                </div>
            </div>

        </div>

        <!--    End : Filter Options Grid-->

    </div>
</form>
